import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './navigation/AuthProvider';
import { RootAuthProvider } from './navigation/RootAuthProvider';
import TemporaryUserInfo from './navigation/TemporaryUserInfo';
import toast, { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
  console.log = () => null;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        basename={process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : ''}>
        <TemporaryUserInfo>
          <AuthProvider ref={RootAuthProvider}>
            <App />
            <Toaster />
          </AuthProvider>
        </TemporaryUserInfo>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
